import { Chip } from "@mui/joy";
import { useTranslation } from "react-i18next";

/**
 * `wrap` is for labels longer than "BETA": they have to survive the membership
 * chart's ~73px mobile column, so the chip shrinks and wraps instead of being
 * clipped. Short labels keep the original fixed-height chip.
 */
function Badge({ label, wrap }: { label: string; wrap?: boolean }): JSX.Element {
  return (
    <Chip
      size="sm"
      variant="solid"
      slotProps={
        wrap
          ? {
              label: {
                sx: {
                  whiteSpace: "normal",
                  textAlign: "center",
                  overflow: "visible",
                  // Safety net for locales whose single words exceed the cell.
                  wordBreak: "break-word",
                },
              },
            }
          : undefined
      }
      sx={{
        fontWeight: 700,
        letterSpacing: wrap ? { xs: 0.2, md: 1 } : 1,
        borderRadius: "6px",
        ...(wrap
          ? {
              fontSize: { xs: "0.5rem", md: "0.625rem" },
              lineHeight: 1.2,
              minHeight: 20,
              height: "auto",
              maxWidth: "100%",
              py: 0.25,
            }
          : { lineHeight: 1, height: 20 }),
        backgroundColor: "#1976D2",
        color: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#1565C0",
        },
      }}
    >
      {label}
    </Chip>
  );
}

export function BetaBadge(): JSX.Element {
  const { t } = useTranslation();

  return <Badge label={t("betaBadge.beta")} />;
}

/** Same chip, promo wording — for features offered for a limited period. */
export function LimitedTimeBadge(): JSX.Element {
  const { t } = useTranslation();

  return <Badge label={t("betaBadge.limitedTime")} wrap />;
}

export default BetaBadge;
